import React from "react";
import styles from "./RadioInput.module.css";

interface RadioInputProps {
  name: string;
  options: { label: string; value: string }[];
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const RadioInput = ({ options, value, onChange }: RadioInputProps) => {
  return (
    <div className={styles.radioGroup}>
      {options.map((option) => (
        <label key={option.value} className={styles.radioLabel}>
          <input
            onChange={onChange}
            type="radio"
            value={option.value}
            checked={value === option.value}
            className={styles.radioInput}
          />
          <span className={styles.customRadio}></span>
          {option.label}
        </label>
      ))}
    </div>
  );
};

export default RadioInput;
